import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crg-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
